import React from 'react';

import InvoiceCard from './invCard';
import { EinvoiceSummaryDTO,BusinessLevels } from '../../../common/types';
import { INVListContainer } from './styles';


interface INVListProps{
    data:EinvoiceSummaryDTO[];
    businessLevel:BusinessLevels;
    businessNumber:string;
    businessId: string;
  }

const InvoicesList: React.FC<INVListProps> = ({
     data,
     businessLevel,
     businessNumber,
     businessId,
})=> (
    <INVListContainer>
        {data[0].invoiceId && data.map((item:any)=>(
            <InvoiceCard
            businessId={businessId}
            key={item.invoiceId}
            invoiceId={item.invoiceId}
            invoiceNumber={item.invoiceNumber}
            invoiceDate={item.invoiceDate}
            invoiceStatus={item.invoiceStatus}
            buyerName={item.buyerName}
            totalInvoiceValue={item.totalInvoiceValue}
            businessLevel={businessLevel}
            businessNumber={businessNumber}
            buyerGstin={item.buyerGstin}
            invoiceType={item.invoiceType}
            />
            ))
        }
    </INVListContainer>
);
export default InvoicesList;
